import React from "react";
import PropTypes from "prop-types";
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog,
  Button,
  LinearProgress,
  Card,
  CardHeader,
  CardContent,
  Typography
} from "@material-ui/core";
import { Row, Col } from "react-flexbox-grid/lib/index";

import Inspector from "react-json-inspector";

const MakeTemplateToDeviceResultModal = props => {
  /*

  {
  "status": "success",
  "namespace": "http://www.devicemagic.com/xforms/14da1d20-cd2f-0133-14bd-22000bc00064?38cad760-2ddf-0135-ce8f-22000a1ed9c7",
  "form_name": "2017-06-05 Zooplankton Lab - fgbvun27ka (recalled)"
  }

*/
  let result = "";

  if ("status" in props.makeTemplateDeviceResponse) {
    const deviceIndex = props.devices
      .map(d => d.identifier)
      .indexOf(props.makeTemplateDeviceResponse.device_identifier);
    if (props.makeTemplateDeviceResponse.status === "success") {
      result = (
        <Typography>
          Template Sent: <b>{props.makeTemplateDeviceResponse.form_name}</b>
          <br />
          To device:{" "}
          <b>
            {props.devices[deviceIndex].name ||
              props.devices[deviceIndex].email}
          </b>
          <div style={{ marginTop: "5px", marginBottom: "10px" }}>
            Templates can be edited on the mobile device and submitted, which
            will save the template for later retrieval from the portal.
            Alternatively the form can be used immediately for data entry. If
            this is the case, insure the template question at the end of the
            form is set to &apos;No&apos;.
          </div>
        </Typography>
      );
    } else {
      result = (
        <div>
          <Typography>
            <b>Error: {props.makeTemplateDeviceResponse.message}</b>
          </Typography>
        </div>
      );
    }
  }

  return (
    <Dialog
      open={props.isMakeTemplateToDeviceStatusModalOpen}
      fullWidth
      max-width="xl"
      modal
    >
      <DialogTitle>Send as Template to Device</DialogTitle>
      <DialogContent>
        <Row>
          <Col xs={12}>
            {props.isSendingTemplateToDevice ? <LinearProgress /> : result}
          </Col>
        </Row>

        {!props.isSendingTemplateToDevice ? (
          <Row>
            <Col xs={11}>
              <Card>
                <CardHeader
                  title="View Response"
                  actAsExpander
                  showExpandableButton
                />
                <CardContent expandable>
                  <Inspector
                    search={false}
                    data={props.makeTemplateDeviceResponse}
                  />
                </CardContent>
              </Card>
            </Col>
          </Row>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button primary onClick={props.onMakeTemplateConfirmationCloseClick}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MakeTemplateToDeviceResultModal.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      identifier: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  makeTemplateDeviceResponse: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.string,
    device_identifier: PropTypes.string,
    form_name: PropTypes.string
  }).isRequired,
  onMakeTemplateConfirmationCloseClick: PropTypes.func.isRequired,
  isMakeTemplateToDeviceStatusModalOpen: PropTypes.bool.isRequired,
  isSendingTemplateToDevice: PropTypes.bool.isRequired
};

export default MakeTemplateToDeviceResultModal;
